const items = {
  title: 'Calendars',
  description: 'In this section you can view by month all services and non-conformities generated',

  title1: 'Actions',
  description1: 'Generated Actions or Non-conformities generated in list format',

  title2: 'Places',
  description2: 'Browse through all places and sectors of your company, selecting any of the locations, you can view the equipment',

  title3: 'Map',
  description3: 'View equipment and locations through Google Maps',

  title4: 'Dashboard',
  description4: 'Dashboard with various analyzes and filters',

  title5: 'Equipments',
  description5: 'List of all registered equipments',

  title6: 'Services',
  description6: 'List of all done services',

  title7: 'Third-party company',
  description7: 'Registered third-party companies',
}

export default items;
